<script setup lang="ts">
import { useProjectStore } from '@/stores/project'
import { storeToRefs } from 'pinia'

const { currentItem } = storeToRefs(useProjectStore())
</script>

<template>
  <div class="pb-3">
    <v-tooltip location="bottom" open-delay="500" max-width="300px">
      <template #activator="{ props }">
        <v-card-title class="elip" v-bind="props">
          {{ currentItem?.name }}
        </v-card-title>
      </template>
      <span> {{ currentItem?.name }}</span>
    </v-tooltip>
    <div class="mt-2 pl-4">
      <v-chip class="mr-3" prepend-icon="mdi-map-marker" size="x-small" label>
        {{ currentItem?.location }}
      </v-chip>
      <span class="client-font">
        {{ currentItem?.client }}
      </span>
    </div>
  </div>
</template>

<style scoped></style>
